<form
  id="discussion-form"
  [formGroup]="discussionFormGroup()"
  (ngSubmit)="onSubmitDiscussion()"
  class="w-full flex flex-col gap-lg">
  @if (!submitAttachmentsOnly()) {
    <lib-tiptap-rich-editor
      [placeholder]="'discussion_section_content_placeholder' | transloco"
      [canResize]="true"
      [inputFormControlName]="'content'"
      [enableMentions]="true"
      [mentionSearchFn]="searchMentions"
      (editorInstance)="tiptapEditor.set($event)"
      (mentions)="mentionedUsersControl.setValue($event)">
      <div tiptap-toolbar class="flex items-center justify-between">
        <div class="w-px h-[1.25rem] bg-neutral-300 ms-x-sm me-md"></div>
        <!-- actions -->
        <div class="flex items-center gap-sm">
          <lib-discussion-emoji-picker
            [tiptapEditor]="tiptapEditor()"
            [containerRef]="'discussion-form'"
            [emojiSize]="24"
            [inputFormControlName]="'content'" />

          <lib-upload-files
            [inputFormControlName]="'attachments'"
            [id]="'attachments'"
            [name]="'attachments'"
            [uploadUrl]="uploadFileUrls().upload"
            [removeUrl]="uploadFileUrls().remove"
            [type]="'icon'"
            [accept]="acceptedFileTypes()"
            [uploadedFileLimit]="4"
            [fileSizeLimit]="uploadFileUrlsValidation().maxFileSize"
            [multiple]="true"
            [uploadedFiles]="initialAttachments()"
            (filesChanged)="onAttachmentsChanged($event)"
            [uploadFileLabels]="{
              singleFileAttachedLabel:
                'upload_files_single_file_attached_label' | transloco,
              multipleFilesAttachedLabel:
                'upload_files_multiple_files_attached_label' | transloco,
              addMoreLabel: 'upload_files_add_more_label' | transloco,
              fileUploadTitle: 'upload_files_file_upload_title' | transloco,
              dragAndDropLabel: 'upload_files_drag_and_drop_label' | transloco,
              orLabel: 'upload_files_or_label' | transloco,
              uploadFromComputerLabel:
                'upload_files_upload_from_computer_label' | transloco,
              maxSizeLabel: 'upload_files_max_size_label' | transloco,
              perFileLabel: 'upload_files_per_file_label' | transloco,
              maxFilesLimitLabel:
                'upload_files_max_files_limit_label' | transloco,
              cancelButtonLabel: 'upload_files_cancel_button_label' | transloco,
              continueButtonLabel:
                'upload_files_continue_button_label' | transloco,
              singleFileUploadedLabel:
                'upload_files_single_file_uploaded_label' | transloco,
              multipleFilesUploadedLabel:
                'upload_files_multiple_files_uploaded_label' | transloco,
              singleFileLabel: 'upload_files_single_file_label' | transloco,
              multipleFilesLabel:
                'upload_files_multiple_files_label' | transloco,
              allFormatsAcceptedLabel:
                'upload_files_all_formats_accepted_label' | transloco,
              acceptedFormatLabel:
                'upload_files_accepted_format_label' | transloco,
              acceptedFormatsLabel:
                'upload_files_accepted_formats_label' | transloco,
              uploadedLabel: 'upload_files_uploaded_label' | transloco,
              attachmentsTitle: 'upload_files_attachments_title' | transloco,
              deleteWarningPopupTitle:
                'form_builder_screen_upload_image_warning_popup_title'
                | transloco,
              deleteWarningPopupDeclaimerMessage:
                'upload_image_warning_popup_declaimer_message' | transloco,
              deleteWarningPopupCancelButton:
                'upload_image_warning_popup_cancel_button' | transloco,
              deleteWarningPopupContinueButton:
                'form_builder_screen_upload_image_warning_popup_delete_button'
                | transloco,
            }" />
        </div>
      </div>
    </lib-tiptap-rich-editor>

    <!-- footer -->
    <div class="flex items-center justify-between">
      <div class="flex flex-col gap-sm">
        <lib-validation-message [control]="'content'" />

        <lib-validation-message [control]="'attachments'" />
      </div>

      <div class="flex items-center gap-md">
        @if (commentId()) {
          <button
            type="button"
            (click)="clearForm()"
            class="px-lg py-sm rounded-md text-neutral-500 text-sm font-medium">
            {{ 'discussion_section_discard_button' | transloco }}
          </button>
        }

        <button
          type="submit"
          class="px-lg py-sm rounded-md text-white bg-primary-500 text-sm font-medium">
          {{ 'discussion_section_send_button' | transloco }}
        </button>
      </div>
    </div>
  } @else {
    <input
      formControlName="content"
      id="hidden-content"
      name="content"
      type="hidden" />

    <div class="flex justify-end">
      <lib-upload-files
        [inputFormControlName]="'attachments'"
        [id]="'attachments'"
        [name]="'attachments'"
        [uploadUrl]="uploadFileUrls().upload"
        [removeUrl]="uploadFileUrls().remove"
        [type]="'button'"
        [accept]="acceptedFileTypes()"
        [uploadedFileLimit]="4"
        [fileSizeLimit]="uploadFileUrlsValidation().maxFileSize"
        [multiple]="true"
        [uploadedFiles]="initialAttachments()"
        (continue)="continueAttachments($event)"
        [buttonClass]="'bg-primary-500 text-white font-medium rounded-sm text-lg px-2xl py-sm'"
        [uploadFileLabels]="{
          singleFileAttachedLabel:
            'upload_files_single_file_attached_label' | transloco,
          multipleFilesAttachedLabel:
            'upload_files_multiple_files_attached_label' | transloco,
          addMoreLabel: 'upload_files_add_more_label' | transloco,
          fileUploadTitle: 'upload_files_file_upload_title' | transloco,
          dragAndDropLabel: 'upload_files_drag_and_drop_label' | transloco,
          orLabel: 'upload_files_or_label' | transloco,
          uploadFromComputerLabel:
            'upload_files_upload_from_computer_label' | transloco,
          maxSizeLabel: 'upload_files_max_size_label' | transloco,
          perFileLabel: 'upload_files_per_file_label' | transloco,
          maxFilesLimitLabel: 'upload_files_max_files_limit_label' | transloco,
          cancelButtonLabel: 'upload_files_cancel_button_label' | transloco,
          continueButtonLabel: 'upload_files_continue_button_label' | transloco,
          singleFileUploadedLabel:
            'upload_files_single_file_uploaded_label' | transloco,
          multipleFilesUploadedLabel:
            'upload_files_multiple_files_uploaded_label' | transloco,
          singleFileLabel: 'upload_files_single_file_label' | transloco,
          multipleFilesLabel: 'upload_files_multiple_files_label' | transloco,
          allFormatsAcceptedLabel:
            'upload_files_all_formats_accepted_label' | transloco,
          acceptedFormatLabel: 'upload_files_accepted_format_label' | transloco,
          acceptedFormatsLabel:
            'upload_files_accepted_formats_label' | transloco,
          uploadedLabel: 'upload_files_uploaded_label' | transloco,
          attachmentsTitle: 'upload_files_attachments_title' | transloco,
          buttonLabel: 'upload_files_button_label' | transloco,
          deleteWarningPopupTitle:
            'form_builder_screen_upload_image_warning_popup_title' | transloco,
          deleteWarningPopupDeclaimerMessage:
            'upload_image_warning_popup_declaimer_message' | transloco,
          deleteWarningPopupCancelButton:
            'upload_image_warning_popup_cancel_button' | transloco,
          deleteWarningPopupContinueButton:
            'form_builder_screen_upload_image_warning_popup_delete_button'
            | transloco,
        }" />
    </div>
  }
</form>
